import { useMemo, useState } from 'react';

import { ButtonSpinnerDarkIcon } from '@svgs';

const normalizeColor = (color) => {
  const normalized = String(color || '').toLowerCase();
  if (normalized === 'success') return 'success';
  if (normalized === 'alert' || normalized === 'warning') return 'alert';
  return 'danger';
};

export const ActionObject = ({
  actionName = 'Action',
  actionVerb = 'Processing',
  color = 'danger',
  label,
  note,
  onAction,
  loading = false,
}) => {
  // re-usable "action" (confirm + execute) used within edit panels

  // action confirmation
  const [showConfirmation, setShowConfirmation] = useState(false);

  const normalizedColor = useMemo(() => normalizeColor(color), [color]);

  return (
    <div
      className={`sb-message sb-flex sb-message-action sb-message-action-${normalizedColor}`}
    >
      <div className="sb-flex sb-message-action-inner">
        <span className="sb-message-icon"></span>
        <div className="sb-message-content">
          <p className="sb-message-title">{label}</p>
          <p className="sb-message-msg">{note}</p>
        </div>
      </div>
      {(!showConfirmation || loading) && (
        <button
          type="button"
          className="sb-btn sb-btn-action"
          onClick={() => setShowConfirmation(true)}
        >
          {loading ? `${actionVerb}...` : actionName}
          {loading && <ButtonSpinnerDarkIcon />}
        </button>
      )}
      {showConfirmation && !loading && (
        <div>
          <button
            type="button"
            className="sb-btn sb-btn-action-confirm"
            onClick={onAction}
          >
            Yes, {actionName}
          </button>
          <button
            type="button"
            className="sb-btn sb-btn-action"
            onClick={() => setShowConfirmation(false)}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};


